import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './modules/shared/shared.module';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { StorageService } from './modules/shared/services/storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from './modules/shared/components/loader/loader.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { V1SignInComponent } from './pages/v1-sign-in/v1-sign-in.component';
import { NotificationsService } from './modules/shared/services/notifications.service';
import { A11yModule } from '@angular/cdk/a11y';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ShibbolethSignInComponent } from './pages/shibboleth-sign-in/shibboleth-sign-in.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { ErrorComponent } from './pages/error/error.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MessageService } from 'primeng/api';
// import { PrimengModule } from './primeng.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    SignInComponent,
    V1SignInComponent,
    PrivacyPolicyComponent,
    ShibbolethSignInComponent,
    LogoutComponent,
    ErrorComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    A11yModule,
    SharedModule.forRoot(),
    InfiniteScrollModule
  ],
  providers: [
    StorageService,
    MessageService,
    LoaderService,
    NotificationsService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
      providePrimeNG({
          theme: {
              preset: Aura,
              options: {
                darkModeSelector: '.dark-mode'
              }
          }
      })
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule {
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule
    };
  }
  constructor() {
  }
}
